"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetClassNames = void 0;
exports.MetClassNames = {
    Margin: {
        '1n': 'met-ma-1n',
        '2n': 'met-ma-2n',
        '3n': 'met-ma-3n',
        '4n': 'met-ma-4n',
        '5n': 'met-ma-5n',
        Top: {
            '1n': 'met-mt-1n',
            '2n': 'met-mt-2n',
            '3n': 'met-mt-3n',
            '4n': 'met-mt-4n',
            '5n': 'met-mt-5n',
        },
        Bottom: {
            '1n': 'met-mb-1n',
            '2n': 'met-mb-2n',
            '3n': 'met-mb-3n',
            '4n': 'met-mb-4n',
            '5n': 'met-mb-5n',
        },
        Left: {
            '1n': 'met-ml-1n',
            '2n': 'met-ml-2n',
            '3n': 'met-ml-3n',
            '4n': 'met-ml-4n',
            '5n': 'met-ml-5n',
        },
        Right: {
            '1n': 'met-mr-1n',
            '2n': 'met-mr-2n',
            '3n': 'met-mr-3n',
            '4n': 'met-mr-4n',
            '5n': 'met-mr-5n',
        },
    },
    Padding: {
        '1n': 'met-pa-1n',
        '2n': 'met-pa-2n',
        '3n': 'met-pa-3n',
        '4n': 'met-pa-4n',
        '5n': 'met-pa-5n',
        Top: {
            '1n': 'met-pt-1n',
            '2n': 'met-pt-2n',
            '3n': 'met-pt-3n',
            '4n': 'met-pt-4n',
            '5n': 'met-pt-5n',
        },
        Bottom: {
            '1n': 'met-pb-1n',
            '2n': 'met-pb-2n',
            '3n': 'met-pb-3n',
            '4n': 'met-pb-4n',
            '5n': 'met-pb-5n',
        },
        Left: {
            '1n': 'met-pl-1n',
            '2n': 'met-pl-2n',
            '3n': 'met-pl-3n',
            '4n': 'met-pl-4n',
            '5n': 'met-pl-5n',
        },
        Right: {
            '1n': 'met-pr-1n',
            '2n': 'met-pr-2n',
            '3n': 'met-pr-3n',
            '4n': 'met-pr-4n',
            '5n': 'met-pr-5n',
        },
    },
    FontSizeReset: 'met-fz-reset',
};
